import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import React__default, { useRef, useContext, useEffect, useState } from "react";
import { T as TooltipWord } from "../../TooltipWord.js";
import { useDelayedState } from "../../hooks/useDelayedState.js";
import { useUuid } from "../../hooks/useUuid.js";
import { H as HelpBubble } from "../../HelpBubble.js";
const HOVER_DELAY_MS = 200;
const Tooltip = ({ children, description, testId }) => {
  const helpBubbleId = useUuid();
  const wordRef = useRef(null);
  const { currentTooltip, setCurrentTooltip } = useContext(TooltipOpenContext);
  const [{ showTooltip, keepOpen }, setShowTooltipDelayed, setShowTooltip] = useDelayedState(
    { showTooltip: false, keepOpen: false },
    HOVER_DELAY_MS
  );
  useEffect(() => {
    if (!setCurrentTooltip) {
      return;
    }
    if (showTooltip) {
      setCurrentTooltip(helpBubbleId);
    } else {
      setCurrentTooltip(void 0);
    }
  }, [showTooltip]);
  useEffect(() => {
    if (currentTooltip !== helpBubbleId && typeof currentTooltip !== "undefined") {
      setShowTooltip((prevState) => ({ showTooltip: false, keepOpen: prevState.keepOpen }));
    }
  }, [currentTooltip]);
  const handleDocumentClick = () => {
    if (!showTooltip) {
      setShowTooltip({ showTooltip: false, keepOpen: false });
    }
  };
  useEffect(() => {
    document.addEventListener("mouseup", handleDocumentClick);
    return () => {
      document.removeEventListener("mouseup", handleDocumentClick);
    };
  }, []);
  const handleTooltipClick = () => {
    setShowTooltip((prevState) => ({ showTooltip: !prevState.showTooltip, keepOpen: !prevState.keepOpen }));
  };
  const handleFocus = () => {
    if (!currentTooltip) {
      setShowTooltipDelayed((prevState) => ({ showTooltip: true, keepOpen: prevState.keepOpen }));
    }
  };
  const handleBlur = () => {
    setShowTooltip((prevState) => ({ showTooltip: false, keepOpen: prevState.keepOpen }));
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setShowTooltip((prevState) => ({ showTooltip: !prevState.showTooltip, keepOpen: !prevState.keepOpen }));
    }
    if (e.key === "Escape") {
      setShowTooltip({ showTooltip: false, keepOpen: false });
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      TooltipWord,
      {
        ref: wordRef,
        onClick: handleTooltipClick,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        ariaDescribedById: helpBubbleId,
        testId,
        children
      }
    ),
    /* @__PURE__ */ jsx(HelpBubble, { helpBubbleId, controllerRef: wordRef, role: "tooltip", showBubble: showTooltip || keepOpen, children: description })
  ] });
};
const TooltipOpenContext = React__default.createContext({
  currentTooltip: void 0
});
const TooltipOpenProvider = ({ children }) => {
  const [currentTooltip, setCurrentTooltip] = useState();
  return /* @__PURE__ */ jsx(TooltipOpenContext.Provider, { value: { currentTooltip, setCurrentTooltip }, children });
};
export {
  Tooltip,
  TooltipOpenProvider,
  Tooltip as default
};
//# sourceMappingURL=index.js.map
